import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// project-imports
import Loadable from 'components/Loadable';
import ErrorBoundary from './ErrorBoundary';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';

const Landing = Loadable(lazy(() => import('pages/vektra/landing')));
const CompletionReportPublic = Loadable(lazy(() => import('pages/vektra/public/CompletionReportPublic')));
const EstimatePublic = Loadable(lazy(() => import('pages/vektra/public/EstimatePublic')));
const CustomerProfilePublic = Loadable(lazy(() => import('pages/vektra/public/CustomerProfilePublic')));
const EstimateShortLink = Loadable(lazy(() => import('pages/vektra/public/EstimateShortLink')));
const Error404 = Loadable(lazy(() => import('pages/maintenance/error/404')));

// ==============================|| ROUTES RENDER ||============================== //

// One pathless parent so an error thrown above the authenticated routes — the layout, the auth
// guard, the landing page, the public completion report — renders the same alert the per-route
// boundaries in MainRoutes show, instead of a blank document (OBS-01). The children are unchanged.
const router = createBrowserRouter(
  [
    {
      errorElement: <ErrorBoundary />,
      children: [
        { path: '/', element: <Landing /> },
        { path: '/public/work-orders/:id/completion-report', element: <CompletionReportPublic /> },
        { path: '/public/work-orders/:id/estimate', element: <EstimatePublic /> },
        // CUST-03 — short on purpose: the URL goes out by SMS, where every character counts.
        { path: '/p/:code', element: <CustomerProfilePublic /> },
        // ESTIMATE-05 — the estimate's short link, texted by SMS; resolves to the public estimate page.
        { path: '/e/:code', element: <EstimateShortLink /> },
        LoginRoutes,
        MainRoutes,
        { path: '*', element: <Error404 /> }
      ]
    }
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
